export default defineNuxtRouteMiddleware((to) => {
  if (to.path.startsWith('/my-engagements')) {
    const newPath = to.path.replace(/^\/my-engagements/, '/my-active-engagements')
    return navigateTo({ ...to, path: newPath }, { redirectCode: 301 })
  }

  if (to.path.startsWith('/monitor-active-projects')) {
    const newPath = to.path.replace(/^\/monitor-active-projects/, '/monitor-active-engagements')
    return navigateTo({ ...to, path: newPath }, { redirectCode: 301 })
  }

  if (to.path.startsWith('/leaderboard-opt-ins')) {
    const newPath = to.path.replace(/^\/leaderboard-opt-ins/, '/market-maker-leaderboard')
    return navigateTo({ ...to, path: newPath }, { redirectCode: 301 })
  }
})
